export default __webpack_public_path__ + "static/media/meo_tools_ecosystem.b459226f.png";